<template>
    <div class='component-page'>
        <!--文本搜索位置-->
        
        <!--下拉搜索位置-->
        <div class="edittable-table-height-con">
            <Row class='search-select'>
                <Col span='4'>
                    <Select v-model="formItem.class_id" placeholder="班级" @on-change="changeClass" clearable style="width:200px">
                        <Option v-for="item in classList" :value="item.class_id" :key="item.class_id">{{ item.name }}</Option>
                    </Select>
                </Col>
                <Col span='4'>
                    <Select v-if="formItem.class_id&&formItem.class_id!=''" v-model="formItem.class_lesson_id" placeholder="班级课程" @on-change="handleSearch" clearable style="width:200px">
                        <Option v-for="item in lessonList" :value="item.class_lesson_id" :key="item.class_lesson_id">{{ item.name }}</Option>
                    </Select>
                </Col>
            </Row>
            <Table stripe border :columns="editIncellColumns" :data="editIncellData"></Table>
            <div style="margin: 20px 0 10px 0 ;overflow: hidden;">
                <Page style='float: right'  size="small" :total="total_count" :page-size="formItem.page_size" :current="formItem.page" @on-change="changePage" />
            </div>
        </div>
        <!--提醒弹层-->
        <Modal v-model="remindModal" width="440" class='remind'>
            <div class='remindContent'>
                {{remindContent}}
            </div>
            <div slot="footer">
                <Button type='primary' ghost shape="circle" @click='cancelRemain'>取消</Button>
                <Button type="primary" shape="circle" @click="primaryRemind">确定</Button>
            </div>
        </Modal>
       
    </div>
</template>

<style lang="css">
    @import "../common.css";
</style>
<script>
    import {
        fetchTableList,
        setStatus,
        fetchLessonList,
        fetchClassList
    } from '@/api/courseClear'
    
    export default {
        name: 'user-components',
        data () {
            return {
                total_count: 0, //列表总条数
                formItem:{
                    page: 1, //列表当前页数
                    page_size: 10,
                    proxy_name: '', 
                },
                classList:[],
                lessonList:[],
                remindContent:'',//提醒内容
                remindModal:false,//提醒弹层状态
                editIncellColumns: [
                    {
                        title: '序号',
                        align: 'center',
                        type: 'index',
                       
                    },
                
                    {
                        title: '章节ID',
                        align: 'center',
                        key: 'chapter_id',
                    },
                   
                    {
                        title: '章节名称',
                        align: 'center',
                        key: 'name',
                    },

                    {
                        title: '状态',
                        align: 'center',
                        key: 'is_lock',
                        render: (h, params) => {
                            if(params.row.is_lock==0){
                                return h('span', '已解锁')
                            }else{
                                return h('span', '未解锁')
                            }
                        },
                    },
                  
                    {
                        title: '操作',
                        align: 'center',
                        key: 'action',
                        render: (h, params) => {
                            if(params.row.is_lock==1){
                                return h('div', [
                                   
                                    h('Button', {
                                        props: {
                                            type: 'error',
                                            size: 'small',
                                            ghost: true
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.changeStatus(params.row.chapter_id,'确定解锁该章节吗？')
                                            }
                                        }
                                    }, '解锁'),
                                ])
                            }else{
                                return h('div', [
                                   
                                    h('Button', {
                                        props: {
                                            type: 'primary',
                                            size: 'small',
                                            ghost: true
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.changeStatus(params.row.chapter_id,'确定开锁该章节吗？')
                                            }
                                        }
                                    }, '开锁'),
                                ])
                            }
                           
                        }
                    }
                
                ],//列表
                editIncellData: [],//列表数据
            };
        },
        methods: {
            //获取列表数据
            getData () {
                this.$Loading.start();
                fetchTableList(this.formItem).then(res => {
                    res=res.data;
                    this.$Loading.finish();
                    if(res.code == 200){
                        this.editIncellData = res.data;
                        // this.total_count = parseInt(res.data.total_count);
                    }else if(res.code == 14001){
                        this.$Message.error(res.msg);
                        this.$store.dispatch('handleLogOut').then(res => {
                            this.$store.commit('clearOpenedSubmenu')
                            this.$router.push({
                                name: 'login'
                            })
                        })
                    }else{
                        this.$Message.error(res.msg);
                    }
                })
            },
            getLessonList(id){
                fetchLessonList({
                    class_id:id
                }).then(res => {
                    res=res.data;
                    if(res.code == 200){
                        this.lessonList = res.data;
                       
                    }else if(res.code == 14001){
                        this.$Message.error(res.msg);
                        this.$store.dispatch('handleLogOut').then(res => {
                            this.$store.commit('clearOpenedSubmenu')
                            this.$router.push({
                                name: 'login'
                            })
                        })
                    }else{
                        this.$Message.error(res.msg);
                    }
                })
            },
            getClassList(){
                fetchClassList().then(res => {
                    res=res.data;
                    if(res.code == 200){
                        this.classList = res.data;
                    }else if(res.code == 14001){
                        this.$Message.error(res.msg);
                        this.$store.dispatch('handleLogOut').then(res => {
                            this.$store.commit('clearOpenedSubmenu')
                            this.$router.push({
                                name: 'login'
                            })
                        })
                    }else{
                        this.$Message.error(res.msg);
                    }
                })
            },
            changeClass(){
                this.getLessonList(this.formItem.class_id);
            },
            // 改变状态
            changeStatus(id,info){
                this.chapter_id = id;
                this.remindContent = info;
                this.remindModal = true; 
            },
            //提醒弹出层的确定事件
            primaryRemind(){
                    setStatus({
                        chapter_id:this.chapter_id,
                        class_lesson_id:this.formItem.class_lesson_id
                    }).then(res => {
                        res=res.data;
                        if(res.code==200){
                            this.getData();
                            this.remindModal=false;
                        }else if(res.code == 14001){
                            this.$Message.error(res.msg);
                            this.$store.dispatch('handleLogOut').then(res => {
                                this.$store.commit('clearOpenedSubmenu')
                                this.$router.push({
                                    name: 'login'
                                })
                            })
                        }else{
                            this.$Message.error(res.msg);
                        }
                    })
                
            },
           
            // 关闭提醒弹出
            cancelRemain(){
                this.remindModal = false; 
            },
            //搜索框搜索
            handleSearch () {
                this.formItem.page = 1;
                this.getData();
            },
            //改变当前页码
            changePage (row) {
                this.formItem.page = row;
                this.getData();
            },
            
        },
        created () {
            // this.getData();
            this.getClassList();
        }
    };
</script>
